import script from "./ServicesCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesCatalog.vue?vue&type=script&setup=true&lang=js"

import "./ServicesCatalog.vue?vue&type=style&index=0&id=b3382bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3382bfe"]])

export default __exports__